<template>
  <div class="event-courses">
    <z-title title="市民评价" icon="icon-pingjia"></z-title>
    <div class="data-main" style="padding: 20px">
      <div class="user">
        <user :username="data.createuser" :orgName="data.communityName" :avatar="data.headPicUrl"></user>
      </div>
      <div class="content">
        <i-form style="margin-top: -3px">
          <row>
            <i-col span="16">
              <row :gutter="10">
                <i-col span="12">
                  <form-item class="form-item" label="星级：">
                    <div
                      class="form-item-content"
                      v-for="(item, index) in [1,2,3,4,5]"
                      :key="index"
                      style="display: inline-block"
                    >
                      <!-- 默认的样式 -->
                      <img
                        src="../../../assets/images/star1.png"
                        v-if="index<=data.starts-1"
                        alt
                        style="width: 16px;height: 16px"
                      >
                      <img
                        src="../../../assets/images/star0.png"
                        v-else
                        alt
                        style="width: 16px;height: 16px"
                      >
                    </div>
                  </form-item>
                </i-col>
                <i-col span="12">
                  <form-item class="form-item" label="评价内容：">
                    <div class="form-item-content" v-for="item in data.labels" :key="item">
                      <!-- 默认的样式 -->
                      {{item}}
                    </div>
                  </form-item>
                </i-col>
                <i-col span="12">
                  <form-item class="form-item" label="评价详情：">
                    <div class="form-item-content">
                      <!-- 默认的样式 -->
                      {{data.content}}
                    </div>
                  </form-item>
                </i-col>
              </row>
            </i-col>
          </row>
        </i-form>
      </div>
    </div>
  </div>
</template>

<script>
import ZTitle from "../../../components/EventHeader";
import User from "../../../components/User.vue";
export default {
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      list: [1, 2, 3, 4, 5]
    };
  },
  components: { User, ZTitle }
};
</script>

<style lang='less' scoped>
.event-coures {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  .data-main {
    width: 100%;
    padding: 20px;
  }
}
.data-main {
    display: flex;
    .user {
        width: 470px;
    }
    .content {
        width: calc(100% - 470px);

        .append {
            position: relative;
            p {
                width: auto;
                padding: 1px;
                position: relative;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: red;
                margin-bottom: 10px;
            }
            img {
                position: absolute;
                left: 40%;
                top: 10px;
            }
        }
    }
    .form-item {
        margin-bottom: 0px;
        .form-item-content {
            // word-wrap: break-word;
            display: flex;
            flex-wrap: wrap;
        }

        .state {
            color: #ff9600;
            font-size: 16px;
        }
        .content-files {
            margin-top: 5px;
            display: flex;
            flex-wrap: wrap;
        }
        .sound {
            margin-right: 10px;
            margin-bottom: 10px;
        }
    }
}
/deep/ .ivu-form-item {
    margin-bottom: 0px;
}
/deep/ .ivu-divider-horizontal {
    margin: 2px 0;
}
</style>
